/**
 * web/src/shell/header.tsx — the app header (mark, wordmark, sign-in door,
 * presence line, date) plus its locale date helper, moved verbatim out of
 * App.tsx (card WUHnArc6lNID).
 */
import { signIn as landingSignIn } from '../screens/Landing';

/** Short weekday + day + month in the device's own locale — the header date. */
export function headerDate(): string {
  return new Date().toLocaleDateString(undefined, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  });
}

interface AppHeaderProps {
  onChat: boolean;
  together: boolean;
  presenceHere: boolean;
  presenceText: string;
  todayLabel: string;
}

export function AppHeader({ onChat, together, presenceHere, presenceText, todayLabel }: AppHeaderProps) {
  return (
    <header className={`pear-header${onChat ? '' : ' is-landing'}`}>
      <div className="pear-header-inner">
        <span className={`pear-mark${together ? ' is-together' : ''}`} />
        <h1 className="pear-title">Pear</h1>
        {/* The sign-up door sits ON the wordmark's line (founder email
            2026-10-25, card 5RluBbgTSKCs): it used to hold a row of its
            own above the beats, and the hairline under this header read as
            "a line at the top" of the landing page — both gone. Same id
            walk-landing waits for, same forwarder Landing exports. */}
        {!onChat && (
          <button
            type="button"
            className="landing-signin pear-header-signin"
            id="btn-landing-signin"
            onClick={landingSignIn}
          >
            Sign in / Sign up
          </button>
        )}
        {onChat && (
          <span className="pear-presence">
            {/* The dot marks presence, so it exists only while they are
                here — a grey dot beside "You & Nina" would be asking the
                eye to read a state the app has not observed. */}
            {presenceHere && (
              <span className="pear-presence-dot is-here" aria-hidden="true" />
            )}
            {presenceText}
          </span>
        )}
        {/* Nav balance (Jonathan 2026-10-17): the current date sits in the
            header, in line with the partner names — the row had the couple
            on the left and nothing on the right. Date only, formatted from
            the device's own locale; no timezone logic, no server call. */}
        {onChat && <span className="pear-header-date">{todayLabel}</span>}
        {/* Settings lost its header slot — it lives in the More menu now
            (card yOcdjnR6pXBz: reachable only via More). */}
      </div>
    </header>
  );
}
